import {ReactNode} from 'react';
import {FormikErrors, FormikTouched} from 'formik';

type FieldErrorProps = {
  children: ReactNode,
  className: string
}

export type ValidationErrorProps = {
  className?: string,
  error: string | undefined |
    string[] | FormikErrors<any> | FormikErrors<any>[],
  touched: boolean | undefined | FormikTouched<any> | FormikTouched<any>[]
}


type ValidationApiErrorProps = {
  className?: string,
  errors: string[] | null,
}

export const FieldErrors = ({children, className}: FieldErrorProps) => (
  <p className={className ?
   'field-error ' + className : 'field-error'}>{children}</p>
);

export const ValidationError =
 ({className='', error, touched}: ValidationErrorProps) => {
   if (!(error && touched)) {
     return null;
   }

   return <FieldErrors className={className}>{error}</FieldErrors>;
 };

export const ApiValidationError =
  ({className='', errors}: ValidationApiErrorProps) => {
    if (!errors?.length) return null;

    return (
      <div className={className}>
        {errors.map((error) => error)}
      </div>);
  };
